import { Icon } from '@testsigma/atoms';
import React, { useEffect, useRef, useState } from 'react';

const Caraousel = ({ itemsList }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalId = useRef(null);

  useEffect(() => {
    if (activeIndex > itemsList.length - 1) {
      setActiveIndex(0);
    }
    if (itemsList.length > 1) {
      intervalId.current = setInterval(() => {
        setActiveIndex((prev) => {
          if (prev >= itemsList.length - 1) {
            return 0;
          }
          return prev + 1;
        });
      }, 10000);
    }

    return () => {
      clearInterval(intervalId?.current);
    };
  }, [itemsList, activeIndex]);

  const onClickNext = () => {
    setActiveIndex((prev) => {
      if (prev == itemsList.length - 1) {
        return 0;
      }
      return prev + 1;
    });
  };

  const onClickPrevious = () => {
    setActiveIndex((prev) => {
      if (prev == 0) {
        return itemsList.length - 1;
      }
      return prev - 1;
    });
  };

  if (itemsList?.length > 0) {
    return (
      <div className='relative w-full'>
        {itemsList[activeIndex]}
        {itemsList?.length > 1 && (
          <div className='absolute left-3 top-1/2 -translate-y-1/2 z-10 flex items-center'>
            <Icon
              name='angle-left'
              className='text-primary-1000 text-lg font-semibold cursor-pointer mr-0.5'
              onClick={onClickPrevious}
            />
            <span className='text-primary-1000 font-semibold text-xs inline-block min-w-[30px] mr-0.5 select-none'>
              {activeIndex + 1} / {itemsList.length}
            </span>
            <Icon
              name='angle-right'
              className='text-primary-1000 text-lg font-semibold cursor-pointer'
              onClick={onClickNext}
            />
          </div>
        )}
      </div>
    );
  }
};

export default Caraousel;
